import { createContext, useContext } from "react";

// true cuando se muestra la sidebar de escritorio (web, pantalla ancha y con
// sesión iniciada; ver App.js). Las pantallas lo usan para no dibujar su
// AppBar de categorías ni la BottomToolbar, que en ese caso viven en la
// sidebar. Vive en su propio archivo para no sumar imports circulares con
// App.js (PublishSpeedDial ya importa de ahí).
export const DesktopSidebarContext = createContext(false);

export const useDesktopSidebar = () => useContext(DesktopSidebarContext);
